<template>
  <v-menu :nudge-width="300" activator="parent">
    <v-card class="mx-auto" width="220">
      <template #title>
        <div class="full-name-container">
          {{ getUserFullName() }}
        </div>
      </template>
      <v-list>
        <!-- Language selection group -->
        <v-list-group value="$t('i18n.language')">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-translate" :title="$t('i18n.language')"></v-list-item>
          </template>
          <v-list-item v-for="locale in availableLocales" :key="`locale-${locale}`" :value="locale" @click="selectLanguage(locale)">
            <template v-slot:prepend>
              <v-icon v-if="currentLanguage === locale" icon="mdi-check"></v-icon>
              <v-icon v-else></v-icon>
            </template>
            <v-list-item-title v-text="locale"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Divider -->
        <v-divider></v-divider>
        <v-list-item @click="logoff">
          <template v-slot:prepend>
            <v-icon icon="mdi-logout"></v-icon>
          </template>
          <v-list-item-title>{{ $t('i18n.logoff') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue'
import i18n from '@/translations/i18n'
import { useAppStore } from '@/stores/appStore'
import { useRouter } from 'vue-router'
import { api } from '@/utils/HelperFunctions'
import { logout } from '@/utils/keyCloak'

export default defineComponent({
  name: 'NavBarUserMenu',
  setup() {
    const router = useRouter()
    const availableLocales = computed(() => i18n.global.availableLocales)
    const currentLanguage = computed(() => i18n.global.locale)
    const appStore = useAppStore()

    const isMobileView = ref(window.innerWidth < 960)
    const updateView = () => {
      isMobileView.value = window.innerWidth < 960
    }

    onMounted(() => {
      window.addEventListener('resize', updateView)
    })

    return {
      router,
      availableLocales,
      currentLanguage,
      appStore,
      isMobileView
    }
  },
  methods: {
    async logoff() {
      await logout()
    },
    navigate(routeName: string) {
      this.router.push({ name: routeName })
    },
    selectLanguage(locale: 'pt' | 'en') {
      i18n.global.locale = locale
    },
    getUserFullName(): string {
      if (!this.appStore.getAppState.userProfile || !this.appStore.getAppState.userProfile.firstName || !this.appStore.getAppState.userProfile.lastName) {
        return ''
      }
      return this.appStore.getAppState.userProfile?.firstName + ' ' + this.appStore.getAppState.userProfile?.lastName
    }
  }
})
</script>

<style lang="scss" scoped>
.full-name-container {
  font-weight: bold;
  padding: 0.5em 0;
  font-size: 16px;
}
</style>
